import { TFunction } from 'i18next';
import KPIData from 'models/kpi/kpiData';
import Task from 'models/tasks/task';

export enum IntegrationRunStatus {
  pending = 0, //scheduled in future
  running = 1, //currently running
  completed = 5, //finished running
  failed = 8, //finished running with failure, will be retried if retry count not exceeded
  dead = 9, //finished running with failure and retry count exceeded, will not be retried again
}

export class IntegrationRun {
  integrationRunId: number;

  integrationId: number;

  status: IntegrationRunStatus;

  retryCount: number;

  created: Date;

  dueAt: Date;

  lockedUntil?: Date;

  lockOwner?: string;

  started?: Date;

  completed?: Date;

  error?: string;

  kpiId?: number;

  kpiDataId?: number;

  taskId?: number;

  data?: KPIData;

  task?: Task;

  constructor() {
    this.integrationRunId = 0;
    this.integrationId = 0;
    this.status = IntegrationRunStatus.pending;
    this.retryCount = 0;
    this.created = new Date();
    this.dueAt = new Date();
  }

  hasError(): boolean {
    return this.status === IntegrationRunStatus.dead;
  }

  isAccepted(): boolean {
    return this.status === IntegrationRunStatus.completed && this.data?.getRunOutcome() !== false;
  }

  isRejected(): boolean {
    return this.status === IntegrationRunStatus.completed && this.data?.getRunOutcome() === false;
  }

  isRejectectAndNotFixed(): boolean {
    return this.hasError() || (this.isRejected() && !this.task?.completed);
  }

  static getRunStatusText = (runStatus: IntegrationRunStatus | undefined, t: TFunction<string[]>): string => {
    switch (runStatus) {
      case IntegrationRunStatus.completed:
        return t('integrations:Run.Status.Completed');
      case IntegrationRunStatus.failed:
        return t('integrations:Run.Status.Failed');
      case IntegrationRunStatus.pending:
        return t('integrations:Run.Status.Pending');
      case IntegrationRunStatus.running:
        return t('integrations:Run.Status.Running');
      case IntegrationRunStatus.dead:
        return t('integrations:Run.Status.Dead');
      default:
        return t('integrations:Run.Status.Pending');
    }
  };
}
